import React, { Component } from 'react';

import Uuid from '../../../../../support/Uuid';
import DocumentoImpuestosTrasladosList from './DocumentoImpuestosTrasladosList';
import DocumentoImpuestosTrasladosForm from './DocumentoImpuestosTrasladosForm';

class DocumentoImpuestosTrasladosManager extends Component {

  state = {}

  handleOnAdd = (data) => {
    const { ImpuestosDR = [] } = this.props.data;
    const { TrasladosDR = [] } = ImpuestosDR;
    const { TrasladoDR = [] } = TrasladosDR;

    const newData = TrasladoDR.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newData);
  }

  handleOnListChange = (data) => {
    const newData = {
      TrasladosDR: {
        TrasladoDR: data
      }
    }

    this.props.onChange(newData);
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  render() {
    const { data } = this.state;
    const { ImpuestosDR = [] } = this.props.data;
    const { TrasladosDR = [] } = ImpuestosDR;
    const { TrasladoDR = [] } = TrasladosDR;

    return (
      <fieldset>
        <legend>Traslados</legend>

        <div data-testid="documento-impuestos-traslados-form">
          <DocumentoImpuestosTrasladosForm
            data={ data }
            onAdd={ this.handleOnAdd }
          />
        </div>

        <DocumentoImpuestosTrasladosList
          data={ TrasladoDR }
          onEdit={ this.handleOnEdit }
          onChange={ this.handleOnListChange }
        />
      </fieldset>
    )
  }
}

export default DocumentoImpuestosTrasladosManager;